'use strict';

var _slicedToArray = require("/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('react'),
    useCallback = _require.useCallback,
    useState = _require.useState,
    useLayoutEffect = _require.useLayoutEffect;

function getSize(el) {
  if (!el) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: el.offsetWidth,
    height: el.offsetHeight
  };
}

function useComponentSize(ref) {
  var _useState = useState(getSize(ref ? ref.current : {})),
      _useState2 = _slicedToArray(_useState, 2),
      ComponentSize = _useState2[0],
      setComponentSize = _useState2[1];

  var handleResize = useCallback(function handleResize() {
    if (ref.current) {
      setComponentSize(getSize(ref.current));
    }
  }, [ref]);
  useLayoutEffect(function () {
    if (!ref.current) {
      return;
    }

    handleResize();

    if (typeof ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(function () {
        return handleResize();
      });
      resizeObserver.observe(ref.current);
      return function () {
        resizeObserver.disconnect(ref.current);
        resizeObserver = null;
      };
    } else {
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [ref.current]);
  return ComponentSize;
}

module.exports = useComponentSize;